import React from "react";
import { motion } from "framer-motion";
import { STRATEGIES } from "../../util/portfolioBuilderLogic";

const MARKETS = [
  {
    key: "Nasdaq",
    label: "Nasdaq futures",
    detail: "Breakout & trend systems on MNQ / NQ",
    color: "#818cf8",
    match: (s) => s.market === "MNQ" || s.market === "NQ",
  },
  {
    key: "Gold",
    label: "Gold futures",
    detail: "Mean reversion / breakout on micro gold",
    color: "#eab308",
    match: (s) => s.market === "MGC",
  },
  {
    key: "Gas",
    label: "Natural gas",
    detail: "Independent energy volatility sleeve",
    color: "#10b981",
    match: (s) => s.market === "NG",
  },
];

/**
 * Visual map of the ZTA suite: strategies clustered by instrument family.
 * Pure presentation; no live data fetch.
 */
export default function DiversificationVisual() {
  return (
    <div className="grid lg:grid-cols-3 gap-5">
      {MARKETS.map((market, idx) => {
        const strategies = STRATEGIES.filter(market.match);
        return (
          <motion.div
            key={market.key}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: idx * 0.08 }}
            className="relative overflow-hidden rounded-2xl border border-white/[0.08] bg-white/[0.025] p-6"
          >
            <div
              className="absolute -top-16 -right-16 w-40 h-40 rounded-full blur-3xl opacity-30"
              style={{ background: market.color }}
            />
            <div className="relative">
              <div className="flex items-center gap-3 mb-5">
                <span
                  className="w-3 h-3 rounded-full shadow-[0_0_18px_currentColor]"
                  style={{ background: market.color, color: market.color }}
                />
                <div>
                  <p className="text-xs uppercase tracking-widest text-zinc-500 font-semibold">
                    Sleeve {String(idx + 1).padStart(2, "0")}
                  </p>
                  <h3 className="font-display text-2xl text-white tracking-tight">
                    {market.label}
                  </h3>
                </div>
              </div>
              <p className="text-sm text-zinc-400 mb-5 leading-relaxed">{market.detail}</p>
              <ul className="space-y-2.5">
                {strategies.map((s) => (
                  <li
                    key={s.id}
                    className="flex items-center justify-between gap-3 rounded-xl border border-white/[0.06] bg-black/30 px-3.5 py-2.5"
                  >
                    <div className="flex items-center gap-2.5 min-w-0">
                      <span
                        className="w-2 h-2 rounded-full flex-shrink-0"
                        style={{ background: s.color }}
                      />
                      <span className="text-sm text-zinc-200 font-medium truncate">
                        {s.name.replace(/_/g, " ")}
                      </span>
                    </div>
                    <span className="text-[11px] text-zinc-500 uppercase tracking-wider flex-shrink-0">
                      {s.market}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
}
